export default __webpack_public_path__ + "static/media/buzzkill.b25661d3.gif";